<template>
    <div class="sec-cont">
        <Head :title="__('Users')" />
        <div class="mb-6 flex flex-col md:flex-row gap-3 justify-between items-center ticket-filters">
            <search-input v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset"></search-input>
<!--            <div class="filter-add-new flex flex-col gap-3 md:flex-row w-full items-center max-w-md">
                <select-input v-model="form.role_id" class=" mr-2 w-full">
                    <option :value="null">{{ __('Filter by role') }}</option>
                    <option v-for="(r, ri) in roles" :key="ri" :value="r.id">{{ r.name }}</option>
                </select-input>
                <Link class="btn-indigo" :href="route('users.create')">
                    <span>{{ __('Create New') }}</span>
                </Link>
            </div>-->
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">{{ __('Name') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Contact Number') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Email') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Marital Status') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Experience') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Application Status') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Training Complete') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Action ') }}</th>
                </tr>
                <tr v-for="user in applications.data" :key="applications.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500">
                            <img v-if="user.photo" class="block -my-2 mr-2 w-5 h-5 rounded-full" :src="user.photo" />
                            {{ user.name }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                            {{ user.contact_number }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                            {{ user.email }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                            {{ user.marital_status }}
                        </Link>
                    </td>
                    <td class="border-t capitalize">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                            {{ user.work_experience ? user.work_experience:null }}
                        </Link>
                    </td>

                    <td class="border-t capitalize">
                        <Link class="flex items-center px-6 py-4" :class="{ 'text-red-500': user.application_status_id === 5, 'text-green-600' :user.application_status_id === 4 }" tabindex="-1">
                            {{ user.application_status? user.application_status:null }}
                        </Link>
                    </td>

                    <td class="border-t capitalize">
                        <Link class="flex items-center px-6 py-4" :class="{ 'text-red-500': user.training_complete !== 'yes', 'text-green-600' :user.training_complete == 'yes' }" tabindex="-1">
                            {{ user.training_complete }}
                        </Link>
                    </td>


                    <td class="border-t flex items-center px-6 py-4">
                        <Link class="btn btn-primary" :href="route('staff.edit', { applicant: user.id })">
                            Update Staff Info
                        </Link>
                        <Link class="btn btn-primary ml-2" :href="route('staff.view', { applicant: user.id })">
                            View Details
                        </Link>
                    </td>
                </tr>
                <tr v-if="applications.data.length === 0">
                    <td class="px-6 py-4 border-t" colspan="6">No users found.</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="applications.links" />
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import SelectInput from '@/Shared/SelectInput'

export default {
    components: {
        SearchInput,
        Head,
        Icon,
        Link,
        SelectInput,
        Pagination,
    },
    layout: Layout,
    props: {
        filters: Object,
        applications: Object,
        roles: Array,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                //role_id: this.filters.role_id ?? null,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(this.route('admin.staffList'), pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
